import { ColumnHelper } from "@tanstack/react-table";
import { Typography } from "PFComponents/typography";

import { MatchesTableEntry } from "../../../../hooks/use_resource_matches";
import { CustomCell } from "./custom_cell";

type CreateCustomColumnArgs = {
  id: string;
  headerLabel: string;
  getValue: (entry: MatchesTableEntry) => string | undefined;
};

export const createCustomColumn = (
  columnHelper: ColumnHelper<MatchesTableEntry>,
  { id, headerLabel, getValue }: CreateCustomColumnArgs
) =>
  columnHelper.accessor((row) => row, {
    id,
    header: () => (
      <Typography withMargin variant="labelRegular">
        {headerLabel}
      </Typography>
    ),
    cell: (info) => <CustomCell value={getValue(info.getValue())} />,
    enableSorting: false
  });
